import axios from 'axios';

const apiUrl= window.location.hostname.includes('localhost')  ? 'localhost' : 'unioninformatica.org';
const baseUrl = `http://${apiUrl}:4000/api/v1/boletaDigital/`; // ajustar si es necesario

export const getUsers = () => axios.get(`${baseUrl}allusers`);

export const createUser = (data) => axios.post(`${baseUrl}createNewUser`, data);

export const updateUser = (data) => axios.post(`${baseUrl}updateUser`, data);

export const deleteUser = (data) => axios.post(`${baseUrl}deleteUser`, data);
